import { Button, Typography } from 'antd';
import { FieldTimeOutlined } from '@ant-design/icons';
import { createSearchParams, useNavigate } from 'react-router-dom-v5-compat';
import { subDays } from 'date-fns';
import { ShipiumTag } from '../../shared/ShipiumTag';
import { useStoreState } from '../../../store';
import { getContextStatus } from './utils';

const { Text } = Typography;

export const PAST_DAYS = 7;
export interface FulfillmentContextTagProps {
  contextId: string;
  isValid: boolean;
  archived: boolean;
  recentCarrierSelectionCount: number;
  validationMessages: string[];
}

export const FulfillmentContextTag = ({
  contextId,
  isValid,
  archived,
  recentCarrierSelectionCount,
  validationMessages,
}: FulfillmentContextTagProps) => {
  const navigate = useNavigate();
  const sessionPartnerSlug = useStoreState((state) => state?.session?.user?.sessionPartnerUrl);

  const { label, color, icon } = getContextStatus({
    archived,
    isValid,
    recentCarrierSelectionCount,
  });

  return (
    <>
      <ShipiumTag
        style={{
          fontSize: 16,
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 15,
          paddingRight: 15,
          width: 140,
          textAlign: 'center',
        }}
        icon={icon}
        color={color}
        dark={true}
      >
        {label}
      </ShipiumTag>
      <div style={{ marginTop: 6, marginLeft: 5 }}>
        {isValid && !archived && recentCarrierSelectionCount !== -1 && (
          <Button
            type={'link'}
            style={{
              height: 'auto',
              margin: 0,
              padding: 0,
              fontSize: 12,
            }}
            onClick={() =>
              navigate({
                pathname: `/${sessionPartnerSlug}/delivery-reporting/shipment-search/`,
                search: `?${createSearchParams({
                  'fulfillment-context': contextId,
                  'start-date': subDays(new Date(), PAST_DAYS).toISOString(),
                  'end-date': new Date().toISOString(),
                })}`,
              })
            }
          >
            <span
              style={{
                whiteSpace: 'normal',
                maxWidth: '250px',
                textAlign: 'left',
              }}
            >
              Past {PAST_DAYS} days <FieldTimeOutlined />
            </span>
          </Button>
        )}
        {!isValid && !archived && (
          <Text type={'danger'} style={{ fontSize: 12 }}>
            <ul>
              {validationMessages.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
          </Text>
        )}
      </div>
    </>
  );
};
